<template>
  <section class="b-rating-filter">
      <div class="b-rating-filter__heading">
        <h4 class="b-rating-filter__title">
          Рейтинг ЖК
        </h4>
        <span class="b-rating-filter__count">
          {{comments_count}}
         {{num_word(comments_count, words)}}
      </span>
      </div>


    <div class="b-rating-filter__b-rating">
      <div class="b-rating-filter__b-rating-stars">
        <star-rating
            :star-size="24"
            :show-rating="false"
            :read-only="true"
            :rating="common_rating"
            active-color="#FDC20B"
            inactive-color="rgba(253, 194, 11, 0.3)"
            :round-start-rating="false"

        ></star-rating>
      </div>
    <div>
        <span class="b-rating-filter__b-rating-text">
        Рейтинг ЖК:
      </span>
      <span class="b-rating-filter__b-rating-val" style="">
        {{common_rating}}
      </span>
    </div>

      <button class="btn b-rating-filter__mobile-btn" @click.prevent="showModal()">
        <svg viewBox="0 0 24 24" >
          <use xlink:href="/assets/site/images/sprites.svg?ver=39#sprite-filters-btn"></use>
        </svg>
      </button>
    </div>
    <ul class="b-rating-filter-list">
      <li class="b-rating-filter-list__item" v-for="(item, index) in list">
        <div class="b-rating-filter-list__rating">
          <label class="form-checkbox b-rating-filter-list__checkbox" >
            <input type="checkbox" name="conf_policy" class="form-checkbox__input" v-model="item.checked" @input="filterByRating(item.rating)">
            <span class="form-checkbox__checkmark"></span>
          </label>
          <star-rating
              :star-size="18"
              :show-rating="false"
              :read-only="true"
              :rating="item.rating"
              active-color="#FDC20B"
              inactive-color="rgba(253, 194, 11, 0.3)"
              :round-start-rating="false"
          ></star-rating>
        </div>

        <span class="b-rating-filter-list__scale">
          <span class="b-rating-filter-list__scale-bg" v-bind:style="{width:(item.count / ratings_count * 100) + '%'}"></span>
        </span>
        <span class="b-rating-filter-list__count">{{item.count}}</span>
      </li>
    </ul>

    <div class="modal fade contact_form_modal" id="filtersModal" @click.self="closeModal" v-if="ShowModal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content"  >
          <div class="modal-header b-rating-filter__modal-header">
            <h4 class="b-rating-filter__modal-title">Фильтры</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="closeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h5 class="b-rating-filter__bl-title">Сортировать</h5>
            <div class="b-rating-filter__sort">
              <label class="btn-radio">
                Популярные
                <input type="radio" name="sort" class="btn-radio__input" @input="commentsSort('popular')">
                <span class="btn-radio__checkmark"></span>
              </label>
              <label class="btn-radio">
                По дате
                <input type="radio" name="sort" class="btn-radio__input" @input="commentsSort('date')">
                <span class="btn-radio__checkmark"></span>
              </label>
            </div>
            <h5 class="b-rating-filter__bl-title">Оценка</h5>
            <ul class="b-rating-filter-list b-rating-filter-list--mobile">
              <li class="b-rating-filter-list__item" v-for="(item, index) in list">
                <div class="b-rating-filter-list__rating">
                  <label class="form-checkbox b-rating-filter-list__checkbox" >
                    <input type="checkbox" name="conf_policy" class="form-checkbox__input" v-model="item.checked" @input="filterByRating(item.rating)">
                    <span class="form-checkbox__checkmark"></span>
                  </label>
                  <star-rating
                      :star-size="18"
                      :show-rating="false"
                      :read-only="true"
                      :rating="item.rating"
                      active-color="#FDC20B"
                      inactive-color="rgba(253, 194, 11, 0.3)"
                      :round-start-rating="false"
                  ></star-rating>
                </div>

                <span class="b-rating-filter-list__scale">
                   <span class="b-rating-filter-list__scale-bg" v-bind:style="{width:(item.count / ratings_count * 100) + '%'}"></span>
                </span>
                <span class="b-rating-filter-list__count">{{item.count}}</span>
              </li>
            </ul>
            <div class="b-rating-filter__modal-btns">
              <button class="btn btn--100 button-red" @click.prevent="closeModal">
                Показать
                {{comments_count}}
                {{num_word(comments_count, words)}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { bus } from './bus';
import StarRating from 'vue-star-rating'
export default {
  props:{
    common_rating:Number,
    building_id: Number,
    comments_count:Number,
    ratings_count:Number,

  },
  components: {
    StarRating
  },
  data() {
    return {
      words:[
          'отзыв',
          'отзыва',
          'отзывов'
      ],
      list: [],
      filter:[],
      ShowModal:false,
      windowWidth:window.innerWidth,
    }
  },

  methods: {
    commentsSort(type) {
      this.$emit('comments-sort', type);
    },
    showModal() {
      if(!this.$root.filtered && !this.$root.signedIn) {
        this.$root.filtered = true;
        bus.$emit('show-filter-modal')
      }  else {
        this.ShowModal =true;
        let vm =this;
        this.$nextTick(function () {
          $(function () {
            $('#filtersModal').modal('show')
          })

        })
      }

    },
    onResize() {
      this.windowWidth = window.innerWidth
      if(this.windowWidth >1023) {
        this.closeModal();
        this.ShowModal=false;

      }
    },
    closeModal() {
      $('#filtersModal').modal('hide');
      let vm =this;

    },
    filterByRating(rating) {
      if(!this.$root.filtered && !this.$root.signedIn) {
        this.$root.filtered = true;
        bus.$emit('filter-by-rating', rating);
      } else {
        let index = this.filter.indexOf(rating);
        let list_index = this.list.findIndex(x => x.rating === rating);
        if(index >= 0) {
          this.filter.splice(index,1);
          this.list[list_index].checked = false;
        } else {
          this.filter.push(rating);
          this.list[list_index].checked = true;
        }
        this.$emit('filter', this.filter);
      }

    },
    num_word(value, words){
      value = Math.abs(value) % 100;
      var num = value % 10;
      if(value > 10 && value < 20) return words[2];
      if(num > 1 && num < 5) return words[1];
      if(num == 1) return words[0];
      return words[2];
    },
    getList() {
      axios.get('/comments/rating-list/' + this.building_id)
      .then((response) => {
        this.list = response.data;
      })
    }
  },
  mounted() {
    this.getList();
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },
  created() {
    bus.$on('filter-by-rating', this.filterByRating);
    bus.$on('show-filter-modal', this.showModal)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
}
</script>